"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.MENU_SIZES = exports.MenuItem = exports.MenuBody = void 0;
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../../mantine-hooks/src");
var ActionIcon_1 = require("../ActionIcon/ActionIcon");
var MenuIcon_1 = require("./MenuIcon");
var MenuBody_1 = require("./MenuBody/MenuBody");
Object.defineProperty(exports, "MenuBody", { enumerable: true, get: function () { return MenuBody_1.MenuBody; } });
var MenuBody_styles_1 = require("./MenuBody/MenuBody.styles");
var MenuItem_1 = require("./MenuItem/MenuItem");
Object.defineProperty(exports, "MenuItem", { enumerable: true, get: function () { return MenuItem_1.MenuItem; } });
exports.MENU_SIZES = MenuBody_styles_1.sizes;
var defaultControl = (react_1.default.createElement(ActionIcon_1.ActionIcon, null,
    react_1.default.createElement(MenuIcon_1.MenuIcon, null)));
function Menu(_a) {
    var _b;
    var _c = _a.control, control = _c === void 0 ? defaultControl : _c, children = _a.children, onClose = _a.onClose, onOpen = _a.onOpen, opened = _a.opened, themeOverride = _a.themeOverride, _d = _a.menuPosition, menuPosition = _d === void 0 ? { top: 0, left: 0 } : _d, style = _a.style, menuId = _a.menuId, _e = _a.menuBodyProps, menuBodyProps = _e === void 0 ? {} : _e, _f = _a.closeOnItemClick, closeOnItemClick = _f === void 0 ? true : _f, _g = _a.transitionDuration, transitionDuration = _g === void 0 ? 250 : _g, _h = _a.size, size = _h === void 0 ? 'md' : _h, _j = _a.shadow, shadow = _j === void 0 ? 'md' : _j, _k = _a.transition, transition = _k === void 0 ? 'skew-up' : _k, transitionTimingFunction = _a.transitionTimingFunction, menuButtonLabel = _a.menuButtonLabel, _l = _a.controlRefProp, controlRefProp = _l === void 0 ? 'elementRef' : _l, _m = _a.zIndex, zIndex = _m === void 0 ? 1000 : _m, elementRef = _a.elementRef, others = __rest(_a, ["control", "children", "onClose", "onOpen", "opened", "themeOverride", "menuPosition", "style", "menuId", "menuBodyProps", "closeOnItemClick", "transitionDuration", "size", "shadow", "transition", "transitionTimingFunction", "menuButtonLabel", "controlRefProp", "zIndex", "elementRef"]);
    var controlRefFocusTimeout = react_1.useRef();
    var controlRef = react_1.useRef(null);
    var uuid = hooks_1.useId(menuId);
    var controlled = typeof opened === 'boolean';
    var _o = react_1.useState(false), _opened = _o[0], setOpened = _o[1];
    var menuOpened = controlled ? opened : _opened;
    var handleClose = function () {
        setOpened(false);
        typeof onClose === 'function' && onClose();
        controlRefFocusTimeout.current = window.setTimeout(function () {
            var _a;
            typeof ((_a = controlRef.current) === null || _a === void 0 ? void 0 : _a.focus) === 'function' && controlRef.current.focus();
        }, transitionDuration + 10);
    };
    var handleOpen = function () {
        setOpened(true);
        window.clearTimeout(controlRefFocusTimeout.current);
        typeof onOpen === 'function' && onOpen();
    };
    var wrapperRef = hooks_1.useClickOutside(function () { return menuOpened && handleClose(); });
    var toggleMenu = function () { return (opened || _opened ? handleClose() : handleOpen()); };
    var menuControl = react_1.cloneElement(control, (_b = {
            onClick: toggleMenu,
            role: 'button',
            'aria-haspopup': 'menu',
            'aria-expanded': menuOpened,
            'aria-controls': uuid,
            'aria-label': menuButtonLabel,
            'data-mantine-menu': true,
            title: menuButtonLabel
        },
        _b[controlRefProp] = hooks_1.useMergedRef(controlRef, elementRef),
        _b));
    return (react_1.default.createElement("div", __assign({ "data-mantine-composable": true, ref: wrapperRef, style: __assign({ display: 'inline-block', position: 'relative' }, style) }, others),
        menuControl,
        react_1.default.createElement(MenuBody_1.MenuBody, __assign({}, menuBodyProps, { opened: menuOpened, onClose: handleClose, id: uuid, themeOverride: themeOverride, closeOnClickOutside: false, closeOnItemClick: closeOnItemClick, style: __assign(__assign({}, menuBodyProps.style), menuPosition), transitionDuration: transitionDuration, transition: transition, transitionTimingFunction: transitionTimingFunction, size: size, shadow: shadow, zIndex: zIndex }), children)));
}
exports.Menu = Menu;
Menu.displayName = '@mantine/core/Menu';
